

export enum TipoUsuario {
    PRODUTOR = "PRODUTOR",
    ENGENHEIRO_CONSULTOR = "ENGENHEIRO",
    REPRESENTANTE = "REPRESENTANTE",
    REVENDEDOR = "REVENDEDOR",
    VISITANTE = "VISITANTE",
}